import { API, Helpers, Router } from '../Helpers';
import { Checkbox, Radio, RadioGroup } from 'react-icheck';
import FroalaEditor from 'react-froala-wysiwyg';
import { InputHidden, Select } from '../Core';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactSortable } from "react-sortablejs";

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
        
        this.getLocationOptions = this.getLocationOptions.bind(this);
        this.changeLocation = this.changeLocation.bind(this);
        this.fetchTours = this.fetchTours.bind(this);
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.saveOrder = this.saveOrder.bind(this);
        this.setTours = this.setTours.bind(this);
    }
    
    getLocationOptions()
    {
        let options = this.props.data.locations.data.map((location, index) => {

            return {
                value: location.id,
                text: location.name
            };
        })
        
        return _.sortBy(options, ['text']);
    }
    
    changeLocation(location)
    {
        console.log("changeLocation", location);
        
        this.setState({
            location: _.find(this.props.data.locations.data, (_location) => { return _location.id == location; })
        }, () => 
        {
            this.fetchTours();
        })
    }
    
    fetchTours()
    {
        console.log("fetchTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = {
            location: this.state.location.id,
            per_page: '*',
            sort_by: this.props.data.sort_by.slug,
            status: 'Published'
        };
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                console.log("fetchTours response", response);
                
                this.setState({
                    fetching_tours: false,
                    tours: response
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            fetching_tours: true
        }, () => 
        {
            API.get(onResponse, router.url('fetchTours', payload));
        });
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.small;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    saveOrder()
    {
        const router = Router(this.props.data.routes);
        
        let tours = {};
        
        _.forEach(this.state.tours.data, (_tour, index) => {
            tours[_tour.id] = {
                order: index
            };
        });
        
        let payload = {
            location: this.state.location.id,
            tours: tours
        };
        
        console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                console.log("saveOrder response", response);
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        API.post(onResponse, payload, router.url('saveToursOrder'));
    }
    
    setTours(newState)
    {
        let tours = {...this.state.tours};
                
        tours.data = newState;
        
        this.setState({ 
            tours: tours
        });
    }
        
    render() {
        
        const { active_site, csrf_token, env, locations, routes, sort_by } = this.props.data;
        const router = Router(routes);
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <h3>Edit Tour Order</h3>
                    </div>
                </div>
                
                <div className="row mb-4">
                    <div className="col-4">
                        <Select
                            name="location"
                            placeholder="choose a location"
                            options={this.getLocationOptions()}
                            onChange={this.changeLocation}
                        />
                    </div>
                </div>
                
                {
                    this.state.fetching_tours &&
                    <div className="text-center py-10">
                        <div className="font-weight-bold mb-2">Loading...</div>
                        <div className="spinner-border" role="status" aria-hidden="true"></div>
                    </div>
                }
                
                {
                    !this.state.fetching_tours &&
                    !_.isEmpty(this.state.tours) &&
                    <div className="row">
                        <div className="col-10">
                            <ReactSortable
                                list={this.state.tours.data}
                                setList={(newState) => this.setTours(newState)}
                                className="list-group"
                                onSort={() => {this.saveOrder()}}
                            >
                                {
                                    this.state.tours.data.map((tour, key) => {

                                        return (
                                            <div key={tour.id} className="list-group-item list-group-item-action cursor-pointer p-3 d-flex justify-content-between align-items-center rounded-0 text-left">
                                                <div className="media">
                                                    <div className="mr-3 align-self-center" style={{ maxWidth: '75px' }}>
                                                        <img className="img-fluid" src={this.findProductCoverPhoto(tour)} />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <div className="font-weight-bold">{tour.name}</div>
                                                    </div>
                                                </div> 
                                                
                                                <div><i className="fa fa-arrows-alt"></i></div>
                                            </div>
                                        )
                                    })
                                }
                            </ReactSortable>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

if (document.getElementById('tourOrderer')) {
    
    const element = document.getElementById('tourOrderer');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('tourOrderer'));
}



// WEBPACK FOOTER //
// ./resources/js/components/TourOrderer/App.js